import { LeadType } from '../lead-type.enum';
import {
  getInsuranceFlowLabel,
  getInsuranceFlowStatusClass,
  getLeadStepFromFlowStatus,
  InsuranceFlowStatus,
} from './insurance-flow-status.enum';

export enum InsuranceFlowHistoryStatus {
  OFFER_CREATED = 'OFFER_CREATED',
  OFFER_SENT = 'OFFER_SENT',
  OFFER_REJECTED = 'OFFER_REJECTED',
}

export type InsuranceFlowStateHistoryStatus =
  | InsuranceFlowStatus
  | InsuranceFlowHistoryStatus;

export const getInsuranceFlowHistoryLabel = (
  status: InsuranceFlowStateHistoryStatus
): string => {
  switch (status) {
    case InsuranceFlowHistoryStatus.OFFER_CREATED:
      return $localize`Offre créée`;
    case InsuranceFlowHistoryStatus.OFFER_SENT:
      return $localize`Offre envoyée`;
    case InsuranceFlowHistoryStatus.OFFER_REJECTED:
      return $localize`Offre refusée`;
    default:
      return getInsuranceFlowLabel(status) ?? status;
  }
};

export const getInsuranceFlowHistoryStatusClass = (
  status: InsuranceFlowStateHistoryStatus
): string => {
  switch (status) {
    case InsuranceFlowHistoryStatus.OFFER_CREATED:
      return 'zinc';
    case InsuranceFlowHistoryStatus.OFFER_SENT:
      return 'sky';
    case InsuranceFlowHistoryStatus.OFFER_REJECTED:
      return 'danger';
    default:
      return getInsuranceFlowStatusClass(status);
  }
};

export const getLeadTypeFromHistoryStatus = (
  status: InsuranceFlowStateHistoryStatus
): LeadType => {
  switch (status) {
    case InsuranceFlowHistoryStatus.OFFER_CREATED:
    case InsuranceFlowHistoryStatus.OFFER_SENT:
    case InsuranceFlowHistoryStatus.OFFER_REJECTED:
      return LeadType.PROPOSAL;
    default:
      return getLeadStepFromFlowStatus(status);
  }
};
